/** @type {import('zudoku').ZudokuConfig} */
const config = {
   basePath: "/api-reference",
   sitemap: {
      siteUrl: "https://okisign.com",
   },
   base: "/",
   page: {
      logoUrl: "https://okisign.com",
      logo: {
         src: {
            light: "/api-reference/okisign-text-logo-small.png",
            dark: "/api-reference/okisign-text-logo-small.png",
         },
         alt: "Logo",
      },
   },
   apis: {
      title: "API Reference",
      type: "file",
      input: "./apis/okisign.yaml",
      navigationId: "",
   },
};

export default config;
